<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">{{'Zwischenstopps' | i18n | async}}</span>
        <div class="tmp-section-body tmp-flexy">
            @if(!partner?.filters?.hideMNurDirektflug) {
                <button class="tmp-f-btn" [class.tmp-f-btn-selected]="direktflug === 'N'" (click)="selectStops('N')" matRipple>{{'nur Direktflug' | i18n | async}}</button>
            }
            @if(!partner?.filters?.hideMax1stopp) {
            <button class="tmp-f-btn ml5" [class.tmp-f-btn-selected]="direktflug === '1'" (click)="selectStops('1')" matRipple>{{'max 1 Stopp' | i18n | async}}</button>
            }
            @if(!partner?.filters?.hideMax2stopp) {
            <button class="tmp-f-btn ml5" [class.tmp-f-btn-selected]="direktflug === '2'" (click)="selectStops('2')" matRipple>{{'max 2 Stopps' | i18n | async}}</button>
            }
        </div>
    </div>
</ng-container>